 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		51: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		51: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"18":"en-US"}[chunkId]||chunkId) + "." + {"0":"c8b4950d","1":"3e9b7722","2":"f6a38905","3":"bfcc8a66","4":"c8cdda09","5":"20c1fb7a","6":"d1dd2c41","7":"e8503cee","8":"cb3fc310","9":"264e3ab6","10":"49f55125","11":"319c5561","12":"caaf0d01","13":"6cddb2e9","14":"dddcacd5","15":"0afbcb10","16":"1dcea521","17":"dd7b7c64","18":"cba11126","19":"3687b754","20":"03dde8b6","21":"e4aa2ab1","22":"04baaa6a","23":"82b3b08f","24":"36a05876","25":"c874aa1f","26":"6e7f41a9","27":"ab9aca98","28":"14b29aba","29":"25a531a0","30":"b3f6d8eb","31":"14b0e1a2","32":"599ca9df","33":"279fa576","34":"3791d441","35":"ba4c4688","36":"afda8c28","37":"460fcb90","38":"3da4d152","39":"ca7fa566","40":"95aefa63","41":"0413d717","42":"db147b85","43":"cd79f5a1","44":"5c518cdf","45":"d43751eb","46":"6881cc94","47":"56025b52","48":"482cb23b","49":"1a2bb89c","53":"4e262ea4","54":"5f7025cf","55":"318ffecb","56":"1358746d","57":"861bd57f","58":"a5848bd4","59":"c0844e97","60":"67eada29","61":"954da351","62":"435961ca","63":"c69cc390","64":"014f3e7a","65":"02da0ca6","66":"6603f933","67":"088f79a7","68":"d84a357b","69":"908e4848","70":"d5a91a05","71":"8118de5b","72":"13a237a5","73":"c4486497","74":"9526f519","75":"965b2d93","76":"1a16d317","77":"c6ac1e82","78":"310f9ae5","79":"6c2b756e","80":"e01afc9e","81":"7a83de4c","82":"7a05b03d","83":"b40851b0","84":"38541518","85":"edb4992d","86":"7776559c","87":"d9e63764","88":"4112ee16","89":"d921e3a8","90":"735f8ed0","91":"baf4a89b","92":"8d29e2d4","93":"e538d034","94":"e8b25139","95":"b23c7227","96":"0bdc5cf6","97":"f29762af","98":"d8af0cae","99":"601b098f","100":"b3212e33","101":"8bdfba1b","102":"9b827317","103":"92fbfe99","104":"4859aa99","105":"e59879f7","106":"1f00ced1","107":"da882088","108":"4aa7f830","109":"e7cc31e4","110":"90984015","111":"1dcc138c","112":"63aba5dd","113":"305efe38","114":"0971e6c1","115":"0723fe29","116":"b398086d","117":"cb04c8d3","118":"789c5bad","119":"d70f330e","120":"3944a25f","121":"e56dfa73","122":"4ba342ec","123":"bee46fe4","124":"de3bd02f","125":"bf93d588","126":"d4aef3f7","127":"f4c98a44","128":"1fc92cf8","129":"3b6c3568","130":"2cc384d6","131":"c625d20d","132":"ffa8f9dd","133":"1f6e7135","134":"50407c69","135":"8acb24ef","136":"44100d2e","137":"3406ae0e","138":"a6f3367a","139":"98526901","140":"e95974d2","141":"ac3e483d","142":"8a869f86","143":"de12cf76","144":"5604eb73","145":"51f7c7c1","146":"d44ce632","147":"10bff7b1","148":"f1d7af15","149":"6df6da18","150":"02e49f3c","151":"60785a3b","152":"6a9cf468","153":"5c5504cb","154":"a1a658ef","155":"cfd406b3","156":"c52d2183","157":"882c369b","158":"bd99188b","159":"52ec4cdc","160":"533f2ef7","161":"c2b6eb91","162":"f3e5eb0a","163":"49ab206c","164":"68efc0b2","165":"3ab521b5","166":"fec01994","167":"9ede9ffc","168":"86a79a86","169":"fc2bcd8c","170":"5a8bf817","171":"6beb2cca","172":"e5c3798c","173":"ce17cd3a","174":"0f418a5b","175":"a37a5448","176":"168f01e3","177":"7a547ef4","178":"79ca80c6","179":"cb1efe6a","180":"b34ba9c6","181":"3f9407e2","182":"45d09881","183":"24ffc6b7","184":"59757a14","185":"9fdace4e","186":"869920db","187":"0e9feb35","188":"0d2f7174","189":"c8b12d34","190":"466d8594","191":"bf300ddb","192":"17bf9cdc","193":"f2e19201","194":"4b72c43f","195":"3b6339da","196":"7970f333","197":"45ac1a38","198":"dd5e7a78","199":"4d450421","200":"a989a9b4","201":"e63f96d7","202":"cff9bcd1","203":"82dce56c","204":"efbabb45","205":"4d81a489","206":"55dbe476","207":"5684f14a","208":"5d7df481","209":"f195a0cd","210":"78ab43fa","211":"c253b087","212":"b382f8a3","213":"8a8c00d7","214":"41072d5b","215":"087d5976","216":"ade518b0","217":"824fc7b3","218":"3bb44cfa","219":"bdbf7fe2","220":"2e65a5f7","221":"28225e78","222":"3f8b36cb","223":"404dd856","224":"093428d6","225":"98222040","226":"0c13ac15","227":"e002285f","228":"26d5fca2","229":"8c54b91e","230":"0648b694","231":"4cfdea22","232":"debb58c8","233":"56c5b861","234":"c97889b7","235":"151ea0e8","236":"03429264","237":"1f4f4e22","238":"426e73a2","239":"2efca2d7","240":"375e3d6e","241":"911f0b71","242":"ab29ad14","243":"9bbf5812","244":"de2a1b77","245":"5325bdeb","246":"e3513945","247":"c4efba9e","248":"06e22b9c","249":"20281a01","250":"5631e879","251":"27870116","252":"be5c34cd","253":"47fb9314","254":"0cc4cde8","255":"7ebb2465","256":"d3f82bc8","257":"0f12d9ab","258":"71627fba","259":"6b5b86ec","260":"1b36b48a","261":"c2e3c63a","262":"43767776","263":"4c3d1b23","264":"e3592215","265":"cfc11dc7","266":"6aa54496","267":"1ea7e7d0","268":"f98dd16d","269":"c8108eeb","270":"a66fdcf5","271":"b7e9b03a","272":"6406e000","273":"ab9ebe3e","274":"bcb9f3c5","275":"b6fccc17","276":"92022b14","277":"596d48c2","278":"3d169791","279":"bdf84db4","280":"3add8c95","281":"1593847d","282":"9945f1d0","283":"e889f472","284":"9e546800","285":"2db9993c","286":"96491231","287":"ffd16888","288":"49dbab83","289":"ebb2cb85","290":"d208ac19","291":"c35ee4e1","292":"50c4a228","293":"8070f4ca","294":"fedd114f","295":"e67326e4","296":"fde03f46","297":"7c393d22","298":"f2b5b9f5","299":"daf1a5ea","300":"cd44e984","301":"8e048bca","302":"9536b33d","303":"3ce02c22"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"19":1,"20":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"18":"en-US"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"c54ab676","20":"9c102cd0","21":"31d6cfe0","22":"4cc95dd9","23":"4cc95dd9","24":"4cc95dd9","25":"4962fd05","26":"1354eefe","27":"5f43e99a","28":"7dce66bc","29":"5f43e99a","30":"4cc95dd9","31":"9601a741","32":"5f43e99a","33":"5f43e99a","34":"ed294559","35":"ed294559","36":"31d6cfe0","37":"ed294559","38":"ed294559","39":"ed294559","40":"ed294559","41":"ed294559","42":"79a35d42","43":"ed294559","44":"d601760a","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"31d6cfe0","49":"31d6cfe0","53":"31d6cfe0","54":"31d6cfe0","55":"31d6cfe0","56":"31d6cfe0","57":"31d6cfe0","58":"31d6cfe0","59":"31d6cfe0","60":"31d6cfe0","61":"31d6cfe0","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","68":"31d6cfe0","69":"31d6cfe0","70":"31d6cfe0","71":"31d6cfe0","72":"31d6cfe0","73":"31d6cfe0","74":"31d6cfe0","75":"31d6cfe0","76":"31d6cfe0","77":"31d6cfe0","78":"31d6cfe0","79":"31d6cfe0","80":"31d6cfe0","81":"31d6cfe0","82":"31d6cfe0","83":"31d6cfe0","84":"31d6cfe0","85":"31d6cfe0","86":"31d6cfe0","87":"31d6cfe0","88":"31d6cfe0","89":"31d6cfe0","90":"31d6cfe0","91":"31d6cfe0","92":"31d6cfe0","93":"31d6cfe0","94":"31d6cfe0","95":"31d6cfe0","96":"31d6cfe0","97":"31d6cfe0","98":"31d6cfe0","99":"31d6cfe0","100":"31d6cfe0","101":"31d6cfe0","102":"31d6cfe0","103":"31d6cfe0","104":"31d6cfe0","105":"31d6cfe0","106":"31d6cfe0","107":"31d6cfe0","108":"31d6cfe0","109":"31d6cfe0","110":"31d6cfe0","111":"31d6cfe0","112":"31d6cfe0","113":"31d6cfe0","114":"31d6cfe0","115":"31d6cfe0","116":"31d6cfe0","117":"31d6cfe0","118":"31d6cfe0","119":"31d6cfe0","120":"31d6cfe0","121":"31d6cfe0","122":"31d6cfe0","123":"31d6cfe0","124":"31d6cfe0","125":"31d6cfe0","126":"31d6cfe0","127":"31d6cfe0","128":"31d6cfe0","129":"31d6cfe0","130":"31d6cfe0","131":"31d6cfe0","132":"31d6cfe0","133":"31d6cfe0","134":"31d6cfe0","135":"31d6cfe0","136":"31d6cfe0","137":"31d6cfe0","138":"31d6cfe0","139":"31d6cfe0","140":"31d6cfe0","141":"31d6cfe0","142":"31d6cfe0","143":"31d6cfe0","144":"31d6cfe0","145":"31d6cfe0","146":"31d6cfe0","147":"31d6cfe0","148":"31d6cfe0","149":"31d6cfe0","150":"31d6cfe0","151":"31d6cfe0","152":"31d6cfe0","153":"31d6cfe0","154":"31d6cfe0","155":"31d6cfe0","156":"31d6cfe0","157":"31d6cfe0","158":"31d6cfe0","159":"31d6cfe0","160":"31d6cfe0","161":"31d6cfe0","162":"31d6cfe0","163":"31d6cfe0","164":"31d6cfe0","165":"31d6cfe0","166":"31d6cfe0","167":"31d6cfe0","168":"31d6cfe0","169":"31d6cfe0","170":"31d6cfe0","171":"31d6cfe0","172":"31d6cfe0","173":"31d6cfe0","174":"31d6cfe0","175":"31d6cfe0","176":"31d6cfe0","177":"31d6cfe0","178":"31d6cfe0","179":"31d6cfe0","180":"31d6cfe0","181":"31d6cfe0","182":"31d6cfe0","183":"31d6cfe0","184":"31d6cfe0","185":"31d6cfe0","186":"31d6cfe0","187":"31d6cfe0","188":"31d6cfe0","189":"31d6cfe0","190":"31d6cfe0","191":"31d6cfe0","192":"31d6cfe0","193":"31d6cfe0","194":"31d6cfe0","195":"31d6cfe0","196":"31d6cfe0","197":"31d6cfe0","198":"31d6cfe0","199":"31d6cfe0","200":"31d6cfe0","201":"31d6cfe0","202":"31d6cfe0","203":"31d6cfe0","204":"31d6cfe0","205":"31d6cfe0","206":"31d6cfe0","207":"31d6cfe0","208":"31d6cfe0","209":"31d6cfe0","210":"31d6cfe0","211":"31d6cfe0","212":"31d6cfe0","213":"31d6cfe0","214":"31d6cfe0","215":"31d6cfe0","216":"31d6cfe0","217":"31d6cfe0","218":"31d6cfe0","219":"31d6cfe0","220":"31d6cfe0","221":"31d6cfe0","222":"31d6cfe0","223":"31d6cfe0","224":"31d6cfe0","225":"31d6cfe0","226":"31d6cfe0","227":"31d6cfe0","228":"31d6cfe0","229":"31d6cfe0","230":"31d6cfe0","231":"31d6cfe0","232":"31d6cfe0","233":"31d6cfe0","234":"31d6cfe0","235":"31d6cfe0","236":"31d6cfe0","237":"31d6cfe0","238":"31d6cfe0","239":"31d6cfe0","240":"31d6cfe0","241":"31d6cfe0","242":"31d6cfe0","243":"31d6cfe0","244":"31d6cfe0","245":"31d6cfe0","246":"31d6cfe0","247":"31d6cfe0","248":"31d6cfe0","249":"31d6cfe0","250":"31d6cfe0","251":"31d6cfe0","252":"31d6cfe0","253":"31d6cfe0","254":"31d6cfe0","255":"31d6cfe0","256":"31d6cfe0","257":"31d6cfe0","258":"31d6cfe0","259":"31d6cfe0","260":"31d6cfe0","261":"31d6cfe0","262":"31d6cfe0","263":"31d6cfe0","264":"31d6cfe0","265":"31d6cfe0","266":"31d6cfe0","267":"31d6cfe0","268":"31d6cfe0","269":"31d6cfe0","270":"31d6cfe0","271":"31d6cfe0","272":"31d6cfe0","273":"31d6cfe0","274":"31d6cfe0","275":"31d6cfe0","276":"31d6cfe0","277":"31d6cfe0","278":"31d6cfe0","279":"31d6cfe0","280":"31d6cfe0","281":"31d6cfe0","282":"31d6cfe0","283":"31d6cfe0","284":"31d6cfe0","285":"31d6cfe0","286":"31d6cfe0","287":"31d6cfe0","288":"31d6cfe0","289":"31d6cfe0","290":"31d6cfe0","291":"31d6cfe0","292":"31d6cfe0","293":"31d6cfe0","294":"31d6cfe0","295":"31d6cfe0","296":"31d6cfe0","297":"31d6cfe0","298":"31d6cfe0","299":"31d6cfe0","300":"31d6cfe0","301":"31d6cfe0","302":"31d6cfe0","303":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.funding.elsevier.com/fragments/fragment-factory/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpfragment-factory"] = this["webpackJsonpfragment-factory"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
